import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import ExpImg from "../../images/location/atlanta/exp-app.png";

function Experience(props) {
    return (
        <div className="experience p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="pot-img">
                            <LazyLoadImage
                                src={ExpImg}
                                effect="blur" alt="Tab_01" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="exp-content">
                           <h2>Mark Your Territory in the Potential Market with App Developers in Seattle</h2>
                            <p>Seattle is becoming a technical hub in Washington State as it has raised more than 1.7 billion from startups in 2017. Every other business here is further evolving its digital presence with mobile app development. Meanwhile, Life and Biotech companies have been the major contributors to the overall tech market of this region. Therefore, you can collaborate with Seattle affordable app developers to take your business to new heights making it a potential competitor among the whole industry. It will enable you to set your influential online presence by digitalizing the whole process.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Experience;